import { render, staticRenderFns } from "./paymentTypeList.vue?vue&type=template&id=768ddbb0&"
import script from "./paymentTypeList.vue?vue&type=script&lang=js&"
export * from "./paymentTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports